import { render, staticRenderFns } from "./Model23.vue?vue&type=template&id=529c6eae&scoped=true"
import script from "./Model23.vue?vue&type=script&lang=js"
export * from "./Model23.vue?vue&type=script&lang=js"
import style0 from "./Model23.vue?vue&type=style&index=0&id=529c6eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c6eae",
  null
  
)

export default component.exports